// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".item-cell[data-v-1c6ae213]{border-left:none!important;border-right:none!important}th[data-v-1c6ae213]{position:relative}.hover[data-v-1c6ae213]:hover{cursor:pointer}@media only screen and (min-width:1024px){.hpl-popover[data-v-1c6ae213]:not(.is-widget){display:none}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
